import apiV2 from '~/utils/apiV2'
import { API_VERSION } from 'enums/api'
import { cachedRequest } from '~/utils/jobRequestApiMethods'
import * as types from '~/store/mutation-types'

export const state = () => ({ liveBytesItems: [] })

export const getters = { liveBytesItems: state => state.liveBytesItems }

export const actions = {
  async requestGetLiveBytes({ commit }, { queryParams } = {}) {
    queryParams = queryParams || { take: 50 }
    try {
      const {
        data: { LiveBytes }
      } = await cachedRequest({
        method: this.$axiosV2.get,
        args: [apiV2.liveBytes.getLiveBytes(), { params: queryParams }],
        apiVersion: API_VERSION.V2
      })

      commit(types.SET_LIVE_BYTES_ITEMS, LiveBytes)
    } catch (e) {
      throw e
    }
  }
}

export const mutations = {
  [types.SET_LIVE_BYTES_ITEMS](state, LiveBytes) {
    state.liveBytesItems = LiveBytes
  }
}
